import axios from "axios";

/**
 * Unauthenticated axios instance for public endpoints (login, register, etc.).
 * Does NOT attach Bearer tokens or handle 401 refresh.
 */
const authAxios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: false,
});

export default authAxios;
